import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDashboard } from 'screens/DashboardScreen/dashboard-context';
import Brand from '../Brand';
import DashMenuButton from '../DashMenuButton';
import styles from './style.module.less';
const DashMenuHead = () => {
    const { menuCollapsed, toggleMenuCollapse } = useDashboard();
    return (_jsxs("div", { className: styles.head, children: [_jsx("div", { className: styles.openBtn, children: _jsx(DashMenuButton, { onClick: toggleMenuCollapse }) }), menuCollapsed ? null : (_jsx("div", { className: styles.brand, children: _jsx(Brand, {}) }))] }));
};
export default DashMenuHead;
